<script setup lang="ts">
import { type StepType } from '@/views/auth/gesuch/GesuchPanel.vue'
import { computed } from 'vue'
import { useDisplay } from 'vuetify'
const value = defineModel<StepType>('value')

const { items, loading } = defineProps<{
    items: StepType[]
    loading?: boolean
}>()

const { name: breakpointValue } = useDisplay()

const showLabel = computed(() => {
    switch (breakpointValue.value) {
        case 'xs':
        case 'sm':
        case 'md':
            return false
        case 'lg':
        case 'xl':
        case 'xxl':
            return true
    }
    return true
})
</script>

<template>
    <v-btn-toggle
        v-model="value"
        tile
        class="d-flex flex-wrap"
        borderless
        mandatory
        active-class="primary-darken-3 white--text"
        color="grey-lighten-3 text-inactive"
        style="height:auto"
    >
        <v-btn
            v-for="item of items"
            :key="item.ident"
            :value="item.ident"
            :loading="item.ident === value?.ident && loading"
            :disabled="item.ident !== value?.ident && loading"
            :to="item.to"
            class="tab flex-grow-1"
            :prepend-icon="item.icon"
            exact
            style="height:3rem"
        >
            <span
                v-if="showLabel"
                :style="{ fontWeight: item.ident === value?.ident ? 'bold' : 'normal' }"
                :class="{
                    'text-inactive': item.ident !== value?.ident,
                    label: true,
                    'd-none': true,
                    'd-md-inline': true,
                }"
                >{{ item.text }}
            </span>
        </v-btn>
    </v-btn-toggle>
</template>

<style lang="scss" scoped>
.tab {
    border-top: 1px solid #ccc !important;
}
.label {
    font-size: 0.95rem;
}
.text-inactive {
    color: #000;
}
</style>
